import * as api from './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice-reducers'
import { Message, SendMessagePayload } from 'src/core/models'

export const getUserMessages = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setMessagesListLoading(true))
    const data: Message[] = await api.getMessagesAPI()
    dispatch(reducers.setMessagesListLoading(false))
    dispatch(reducers.setMessagesList(data))
  } catch (error) {
    dispatch(reducers.setMessagesListLoading(false))
  }
}

export const sendMessage = (payload: SendMessagePayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSendMessageLoading(true))
    const message: Message = await api.sendMessageAPI(payload)
    dispatch(reducers.setSendMessageLoading(false))
    dispatch(reducers.setSendMessageSuccess(true))
    dispatch(reducers.addNewMessageSended(message))
  } catch (error) {
    dispatch(reducers.setSendMessageLoading(false))
    dispatch(reducers.setSendMessageError(error))
  }
}

export const readUserMessage = (
  messageId: number, messagesList: Message[]
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setReadMessageCurrentId(messageId))
    dispatch(reducers.setReadMessageLoading(true))
    await api.readMessageAPI(messageId)
    const newMessages = messagesList.map(m => {
      if (m.id === messageId) { return { ...m, read: true }}
      return m
    })
    dispatch(reducers.setMessagesList(newMessages))
    dispatch(reducers.setReadMessageLoading(false))
    dispatch(reducers.setReadMessageSuccess(true))
  } catch (error) {
    dispatch(reducers.resetReadMessage())
  }
}


export const getUserMessagesCount = () => async (dispatch) => {
  try {
    const count = await api.getUserMessagesCountAPI()
    dispatch(reducers.setMessagesCount(count))
  } catch (error) {
    dispatch(reducers.setMessagesCount(null))
  }
}
